import {apolloClient} from '@/setup/apollo-setup';
import {error, newItemSuccess, updateItemSuccess, deleteItemSuccess} from '@/utils/notification';
import {
  GET_EXAMQUESTIONTYPE,
  GET_EXAMQUESTIONTYPES,
  ADD_EXAMQUESTIONTYPE,
  UPDATE_EXAMQUESTIONTYPE,
  DELETE_EXAMQUESTIONTYPE
} from '@/queries/modules/examination/exam-question-type.js';

export async function getExamQuestionTypes(context) {

  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_EXAMQUESTIONTYPES,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });
    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setExamQuestionTypes', data.getExamQuestionTypes);
      context.commit('setSuccess', null);
      return data.getExamQuestionTypes
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getExamQuestionType(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_EXAMQUESTIONTYPE,
        variables: payload,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;


    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setExamQuestionType', data.getExamQuestionType);
      context.commit('setSuccess', null);
      return data.getExamQuestionType
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function addExamQuestionType(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: ADD_EXAMQUESTIONTYPE,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const examQuestionTypes = [...context.state.examQuestionTypes];
      examQuestionTypes.push(data.addExamQuestionType);
      context.commit('setExamQuestionTypes', examQuestionTypes);
      context.commit('setSuccess', newItemSuccess(data.addExamQuestionType.nameLocal));

      return data.addExamQuestionType;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function updateExamQuestionType(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_EXAMQUESTIONTYPE,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {

      const index = context.state.examQuestionTypes.findIndex(item => item.id === data.updateExamQuestionType.id);
      const examQuestionTypes = [
        ...context.state.examQuestionTypes.slice(0, index),
        data.updateExamQuestionType,
        ...context.state.examQuestionTypes.slice(index + 1)
      ];
      context.commit('setExamQuestionTypes', examQuestionTypes);
      context.commit('setSuccess', updateItemSuccess(data.updateExamQuestionType.nameLocal));

      return data.updateExamQuestionType
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function deleteExamQuestionType(context, payload) {
  context.commit('setProcessing', true);

  try {
    const result = await apolloClient
      .mutate({
        mutation: DELETE_EXAMQUESTIONTYPE,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const index = context.state.examQuestionTypes.findIndex(item => item.id === data.deleteExamQuestionType.id);
      const examQuestionTypes = [
        ...context.state.examQuestionTypes.slice(0, index),
        ...context.state.examQuestionTypes.slice(index + 1)
      ];
      context.commit('setExamQuestionTypes', examQuestionTypes);
      context.commit('setSuccess', deleteItemSuccess(data.deleteExamQuestionType.nameLocal));

      return data.deleteExamQuestionType
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

